var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('span',[(_vm.displayIcon)?_c('b-icon-geo-alt'):_vm._e(),_c('b-link',{attrs:{"href":`https://maps.google.com/?q=${_vm.urlEncoded}`,"target":"_blank"},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v(" "+_vm._s(_vm.value)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }